import { useState, useRef, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { FiLogOut } from 'react-icons/fi';
import useAuth from '../../../hooks/useAuth';
import useLogout from '../../../hooks/useLogout';
import { SchoolsDropdown } from './SchoolsDropdown';
import styles from '../css/userMenu.module.css';
import { useNavigate } from 'react-router-dom';
import { ADMIN_SCHOOL_EDIT_ROUTE } from '../../../routes/RoutesPathes';

export const UserMenu = () => {
  const { t, i18n } = useTranslation();
  const navigate = useNavigate();
  const direction = i18n.dir();
  const { auth, school } = useAuth();
  const [open, setOpen] = useState(false);
  const menuRef = useRef(null);
  const logout = useLogout();

  // Close dropdown on outside click
  useEffect(() => {
    const handleClickOutside = (e) => {
      if (menuRef?.current && !menuRef?.current?.contains(e.target)) {
        setOpen(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  const handleLogout = () => {
    logout();
  };

  const handleSchoolManagement = () => {
    navigate(ADMIN_SCHOOL_EDIT_ROUTE);
  };

  return (
    <div className={styles.userMenuWrapper} ref={menuRef}>
      <div className={styles.usernameBox} onClick={() => setOpen((prev) => !prev)}>
      <div 
        className={styles.avatarCircle}
        style={{ 
          // Show light border/white bg only if logo exists
          backgroundColor: school?.logo ? '#fff' : '',
          border: school?.logo ? '1px solid #e0e0e0' : '',
        }}
      >
        {school?.logo ? (
          <img 
            src={school.logo} 
            alt="School Logo" 
            className={styles.avatarImg}
            style={{ 
              width: '100%', 
              height: '100%', 
              borderRadius: '50%', 
              objectFit: 'cover',
              display: 'block' // Default display
            }} 
            // Important: If URL exists but image fails to load
            onError={(e) => {
              e.target.style.display = 'none'; // Hide the broken image
              // Find the initials div (the next sibling) and show it
              const initialsDiv = e.target.nextSibling;
              if (initialsDiv) {
                initialsDiv.style.display = 'flex';
                // Reset parent styles to show background/initials correctly
                e.target.parentElement.style.backgroundColor = ''; 
                e.target.parentElement.style.border = '';
              }
            }}
          />
        ) : null}

        {/* Initials Div: 
            Visible if no logo OR if logo fails (managed by onError) */}
        <div 
          className={styles.initials} 
          style={{ 
            display: school?.logo ? 'none' : 'flex', // Hide if logo is present
            width: '100%',
            height: '100%',
            alignItems: 'center',
            justifyContent: 'center'
          }}
        >
          {auth.firstName?.charAt(0).toUpperCase()}
          {auth.lastName?.charAt(0).toUpperCase()}
        </div>
      </div>
        <div>
          <p className={styles.username}>
            {auth.firstName} {auth.lastName?.charAt(0)}.
          </p>
          <p className={styles.schoolname}>
            {school.name?.length > 15 ? `${school.name.slice(0, 15)}...` : school.name}
          </p>
        </div>
      </div>

      {open && (
        <div className={styles.dropdownMenu}>
          <p
            className={`m-0 ${styles.dropdownitem}`}
            onClick={handleSchoolManagement}
            type="button"
          >
            School Management
          </p>
          <div className={`${styles.dropdownitem} ${styles.schoolsDropdown}`}>
            <SchoolsDropdown />
          </div>
          <div className={styles.dropdownDivider} />
          <p
            className={`m-0 ${styles.dropdownitem}`}
            onClick={handleLogout}
            type="button"
          >
            {t("buttons.logout")}
            <FiLogOut
              className={styles.logoutIcon}
              style={{ transform: direction === 'rtl' ? 'rotate(180deg)' : '' }}
            />
          </p>
        </div>
      )}
    </div>
  );
};
